import * as React from 'react';
import { memo } from 'react';

const SvgEllipse = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 8 8", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("circle", { cx: 4, cy: 4, r: 4, fill: "currentColor" })));
const Memo = memo(SvgEllipse);

export { Memo as default };
